import { useState, useEffect, useCallback } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useAdminTransactionDetail(id) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [related, setRelated] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTransactionDetail = useCallback(async (id) => {
    setLoading(true);

    try {
      const { response, data } = await API.admin.fetchTransaction(token, id);

      if (response.ok) {
        setResult(data.transaction);
        setRelated(data.related);
        setError(null);
      } else {
        setResult(null);
        setError(data.message);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTransactionDetail(id);
  }, [token, id]);

  return {
    loading,
    error,
    transaction: result,
    related: related ?? [],
  };
}
